if (!customElements.get('collection-list')) {
  customElements.define(
    'collection-list',
    class CollectionList extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const sectionId = this.dataset.sectionId;
        const swiperInstances = this.querySelectorAll('[data-instance-id]');

        swiperInstances.forEach((el) => {
          const uniqueId = el.dataset.instanceId;
          const swiperContainer = el.querySelector('.collections-list__products-swiper--' + uniqueId);

          if (swiperContainer) {
            new Swiper(swiperContainer, {
              slidesPerView: 2,
              spaceBetween: 12,
              navigation: {
                nextEl: `.swiper-button-next-${uniqueId}`,
                prevEl: `.swiper-button-prev-${uniqueId}`,
              },
              breakpoints: {
                767: { slidesPerView: 3 },
                1023: { slidesPerView: 4, spaceBetween: 16 },
              },
            });
          }
        });
      }
    }
  );
}
